import { LiveAnnouncer } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Client } from '../../models/client';

@Component({
  selector: 'admin-client-list',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatButtonModule,
    MatIconModule,
    MatSortModule,
    MatMenuModule,
  ],
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss'],
})
export class ClientListComponent implements OnChanges, AfterViewInit {
  @Input() clients!: Client[];

  displayedColumns: string[] = [
    'code',
    'nom',
    'modePaiement',
    'nbreUtilisateur',
    'soldeCredits',
    'reappoAuto',
    'dateDerniereCommande',
    'action',
  ];

  dataSource!: MatTableDataSource<Client>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @Output() creditOrder = new EventEmitter<void>();
  @Output() deleteCredit = new EventEmitter<void>();

  constructor(private _liveAnnouncer: LiveAnnouncer) {}

  ngOnChanges(): void {
    this.dataSource = new MatTableDataSource<Client>(this.clients);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  onCreditOrder() {
    this.creditOrder.emit();
  }

  onDeleteCredit() {
    this.deleteCredit.emit();
  }
}
